/* ========================================================= * Material Kit 2 PRO React - v2.0.0 ========================================================= * Product Page: https://www.creative-tim.com/product/material-kit-pro-react * Copyright 2021 Creative Tim (https://www.creative-tim.com) Coded by www.creative-tim.com ========================================================= * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. */


// next
import dynamic from "next/dynamic";

// prop-types
import PropTypes from "prop-types";

// PRO
const MDBox = dynamic(() => import('/components/MDBox'), { loading: () => null });
const MDTypography = dynamic(() => import('/components/MDTypography'), { loading: () => null });

function DefaultInfoCard({ icon, title, description, direction, small }) {
  return (
    <MDBox lineHeight={1} p={direction === "center" ? 2 : 0} textAlign={direction}>
        <MDTypography
          display="block"
          variant={direction === "center" ? "h2" : "h3"}
          textGradient
        >
          {" "}
          {icon}{" "}
        </MDTypography>
      <MDTypography
        display="block"
        variant="5"
        fontWeight="bold"
        mt={direction === "center" ? 1 : 2}
        mb={1.5}
      >
        {title}
      </MDTypography>
      <MDTypography
        display="block"
        variant={small ? "button" : "body2"}
        color="text"
        pr={direction === "left" ? 6 : 0}
        pl={direction === "right" ? 6 : 0}
        fontWeight="regular"
      >
        {description}
      </MDTypography>
    </MDBox>
  );
}

// Setting default props for the DefaultInfoCard
DefaultInfoCard.defaultProps = {
  direction: "left",
  small: false,
};

// Typechecking props for the DefaultInfoCard
DefaultInfoCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  direction: PropTypes.oneOf(["left", "right", "center"]),
  small: PropTypes.bool,
};

export default DefaultInfoCard;
